export default function () {
  return {
    primaryMenuOpen: false
  };
}
